export const externalThreshold = 'absolute top-[-25px] left-0 h-[28px] w-full transition-all duration-200 flex items-center'

export const itemThreshold = 'absolute top-0 left-0 h-[38px] w-80% transition-all duration-200'

export const internalThreshold = 'absolute top-0 left-0 w-full h-[24px] transition-all duration-200 flex items-center'

export const inputThreshold = 'absolute top-[-18px] left-0 w-full h-[72px] transition-all duration-200 flex items-center'
